<template>
    <div>
        <div class="modal-overlay"></div>
        <div class="modal-container">
            <div class="modal-guide-ment">
                <p v-if="title" class="modal-guide-title">{{ title }}</p>
                <div class="modal-guide-content">
                    <p v-dompurify-html="guideMent"></p>
                    <p v-if="guideSubMent">{{ guideSubMent }}</p>
                </div>
            </div>
            <button @click="$emit('close')" class="modal-guide-close">{{ $t('common.close') }}</button>
        </div>
    </div>
</template>

<script setup>
import { useI18n } from "vue-i18n";
import { defineProps, onMounted, ref } from "vue";

const props = defineProps({
  type: String,
});

const { t } = useI18n();
const title = ref()
const guideMent = ref('')
const guideSubMent = ref('')

const mapMent = {
    'smart': t('alarm.guideMent.smart'),
    'smart-pro': t('alarm.guideMent.smart'),
    'support':  t('alarm.guideMent.sr'),
    'premium': t('alarm.guideMent.pre'),
    'score': t('alarm.guideMent.score'),
    '6.4': t('alarm.guideMent.6.4'),
    'vol': t('alarm.guideMent.vol'),
    'isPayment': t('alarm.guideMent.access2'),
    'next': t('alarm.guideMent.next'),
    'light': t('alarm.guideMent.light'),
}

onMounted(() => {
    title.value = t('alarm.guideMent.access')

    if (props.type == 'permission' || props.type == 'isPayment') {
        title.value = null;
        guideMent.value = t('alarm.guideMent.access1');
        guideSubMent.value = t('alarm.guideMent.access2');
    }
    else {
        guideMent.value = mapMent[props.type]
    }
})
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  z-index: 998;
  background-color: #18181871;
  cursor: pointer;
}

.modal-container {
    position: fixed;
    width: 80%;
    height: fit-content;
    z-index: 1000;
    top: 50%;
    left: 50%;  
    transform: translate(-50%, -50%);
    box-sizing: border-box;

    border-radius: 8px;
    border: 0.8px solid var(--Grayscale-Gray80, #2D3033);
    background: var(--Grayscale-Gray90, #1F2122);

    display: flex;
    flex-direction: column;
    align-items: center;
}

.modal-guide-ment {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 20px 16px;
}

.modal-guide-title {
    color: var(--Main, #FFF);
    text-align: center;
    font-family: "42dot Sans";
    font-size: 16px;
    font-weight: 600;
    line-height: 150%;
    letter-spacing: -0.16px;
    margin-bottom: 8px;
}

.modal-guide-content {
    color: var(--Secondary, #7E8088);
    text-align: center;
    font-size: 16px;
    font-weight: 400;
    line-height: 125%; 
    display: flex;
    flex-direction: column;
}

.modal-guide-close {
    padding: 16px 0;
    display: flex;
    justify-content: center;
    border-top: 0.5px solid var(--Grayscale-Gray80, #2D3033);
    color: var(--Grayscale-Gray10, #F9FBFD);
    
    text-align: center;
    font-size: 16px;
    font-weight: 600;
    line-height: 131.25%;
    width: 100%; 
}

.modal-guide-close:active {
    background-color: rgba(255, 255, 255, 0.06);
    opacity: 0.85;
}
</style>